import Image from 'global/Image';
import { assetPrefix } from 'constants/app';
import BetaLabel from 'global/HomePageLayout/Beta';
import { Hero, HeroTitle, ImageWithShadow, SubTitle, Title } from './styled';
import DownloadButtons from './DownloadButtons';

const DownloadHero = () => (
  <Hero>
    <HeroTitle>
      <Title>
        Stockbit <span className="green">Desktop App</span>{' '}
      </Title>
      <SubTitle>
        Pengalaman Trading Lebih Profesional dengan Aplikasi Saham versi Desktop
        untuk MacOS dan Windows
      </SubTitle>
      <DownloadButtons source="Download Page" />
    </HeroTitle>
    <ImageWithShadow className="image-hero hero" marginTop={-80}>
      <Image className="ellipse" src="/images/Ellipse.svg" />
      <div style={{ position: 'relative' }}>
        <Image
          src="/images/monitor-bezel.svg"
          className="image hero-bezel"
          alt=""
        />
        <video
          style={{
            transition: 'all 0.3s',
          }}
          autoPlay
          loop
          muted
          playsInline
          className="image video-hero"
        >
          <source src={`${assetPrefix}/homepage/desktop-hero.mp4`} />
        </video>
      </div>
    </ImageWithShadow>
    <div
      className="end"
      style={{
        height: '10px',
        paddingTop: '100px',
      }}
    />
  </Hero>
);

export default DownloadHero;
